export const REQUESTITEMS = 'REQUESTITEMS'
export const HOTEL_ROLE_PERMISSION = 'HOTEL_ROLE_PERMISSION'
